// extracted by mini-css-extract-plugin
export default {"founderBg":"styles_founderBg__BSQrK","founderContainer":"styles_founderContainer__fO6ZK"};